import {defineMessages} from 'react-intl';

const messages = defineMessages({
  title: {
    id: 'cannotViewWorkspace',
    defaultMessage: 'Cannot view workspace'
  },
  subtitle: {
    id: 'signOutSignIm',
    defaultMessage: 'Sign out and sign in with a company account to view this workspace.'
  },
  signOut: {
    id: 'signOut',
    defaultMessage: 'Sign out'
  }
});

export default messages;
